/* eslint-disable no-mixed-spaces-and-tabs */
import Vue from 'vue'
import Router from 'vue-router'
import first from '../../public/views/index'
import product from '../../public/views/product'
import productEn from '../../public/views/productEn'
import contact from '../../public/views/contact'
import news from '../../public/views/news'
import newsList from '../../public/views/newsList'
import forms from '../../public/views/forms'
import newListDetail from '../../public/views/newListDetail'
import productDetail from '../../public/views/productDetail'
import about from '../../public/views/about'
import videoCenter from '../../public/views/videoCenter'
import investment from '../../public/views/investment'
import productSummary from '../../public/views/productSummary'
import infomation from '../../public/views/infomation'
import search from '../../public/views/search'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
export default new  Router({
	mode: "history",
    routes:[
		// 首页
        {
            path:'/',
            name:'first',
            component:first
        },
		// 关于稻喜
		{
		    path: '/about',
		    name: 'about',
		    component: about
		},
		// 产品介绍
        {
            path:'/product',
            name:'product',
            component:product
		},
		// 产品介绍-英文
        {
            path:'/productEn',
            name:'productEn',
            component:productEn
		},
		// 产品详情
        {
            path:'/productDetail',
            name:'productDetail',
            component:productDetail
        },
		// 联系我们
		{
		    path:'/contact',
		    name:'contact',
		    component:contact
		},
		// 媒体列表-新闻列表
		{
		    path: '/newsList',
		    name: 'newsList',
		    component: newsList
		},   
		// 通用表单
		{
		    path: '/forms',
		    name: 'forms',
		    component: forms
		},   
		// 文章详情
		{
		    path: '/newListDetail',
		    name: 'newListDetail',
		    component: newListDetail
		},  
		//稻喜资讯
		{
			path:'/infomation',
			name:'infomation',
			component:infomation,
			meta: {
				activeMenu: '/infomation'
			}
		},
		// 媒体
        {
            path:'/news',
            name:'news',
			component:news,
			meta: {
				activeMenu: '/infomation'
			}
        },
		// 视频中心
		{
		    path: '/videoCenter',
		    name: 'videoCenter',
		    component: videoCenter,
			meta: {
				activeMenu: '/infomation'
			}
		},
		//招商加盟
		{
			path:'/investment',
			name:'investment',
			component:investment
		},
		//产品目录--英文版
		{
			path:'/productSummary',
			name:'productSummary',
			component:productSummary
		},
		//搜索结果
		{
			path:'/search',
			name:'search',
			component:search
		},
    ]
})